export default {
      id: "family_restroom-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#family_restroom",
      toString: function () {
        return this.url;
      }
    }